export default "/assets/images/cc-filter-room-03.b5dc49c33edab655.png";